import { useState } from "react";

// Turns the scraped PBJ ground-rules blob (often one run-on paragraph with
// ALL-CAPS section labels like "ALL EVENTS -" / "TRADE DEADLINE -") into clean,
// readable labeled bullets.
function splitRules(text) {
  if (!text) return [];
  let t = text.replace(/\u00a0/g, " ").replace(/[ \t]+/g, " ").trim();
  // Rules already arrive newline-separated from the scraper; also break before a
  // known ALL-CAPS section header when it follows end-of-sentence punctuation.
  t = t.replace(/([.;)])\s+(?=(?:ALL EVENTS|TRADE DEADLINE|GRACE PERIOD|RE-ENTRY|ALL CONTESTANTS|SLACK|PERFORMANCE)\b)/g, "$1\n");
  return t
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const m = line.match(/^([A-Z][A-Z0-9 &./'"-]{2,}?)\s*[-\u2013]\s*(.+)$/);
      if (m && m[2]) return { label: m[1].trim(), body: m[2].trim() };
      return { label: null, body: line };
    });
}

const CLAMP_AT = 260;

function RuleItem({ rule, bullet, labelCls, bodyCls, linkCls }) {
  const [open, setOpen] = useState(false);
  const long = rule.body.length > CLAMP_AT;
  const shown = long && !open ? rule.body.slice(0, CLAMP_AT).replace(/\s+\S*$/, "") + "…" : rule.body;
  return (
    <div className="flex gap-2">
      <span className={`${bullet} font-bold leading-relaxed select-none`}>•</span>
      <p className={`text-sm leading-relaxed ${bodyCls}`}>
        {rule.label && <span className={`font-bold ${labelCls}`}>{rule.label} — </span>}
        {shown}
        {long && (
          <button onClick={() => setOpen((v) => !v)} data-testid="gr-toggle"
            className={`ml-1 font-semibold ${linkCls}`}>{open ? "Show less" : "Show more"}</button>
        )}
      </p>
    </div>
  );
}

export function GroundRulesText({ text, dark = false, className = "" }) {
  const rules = splitRules(text);
  if (!rules.length) return null;
  const bullet = dark ? "text-[#F26D77]" : "text-[#C8000F]";
  const labelCls = dark ? "text-slate-100" : "text-slate-900";
  const bodyCls = dark ? "text-slate-300" : "text-slate-700";
  const linkCls = dark ? "text-[#F26D77] hover:underline" : "text-[#C8000F] hover:underline";
  return (
    <div className={`space-y-2.5 ${className}`} data-testid="ground-rules-formatted">
      {rules.map((r, i) => (
        <RuleItem key={i} rule={r} bullet={bullet} labelCls={labelCls} bodyCls={bodyCls} linkCls={linkCls} />
      ))}
    </div>
  );
}

export default GroundRulesText;
